import script from "./ZdravetoView.vue?vue&type=script&setup=true&lang=js"
export * from "./ZdravetoView.vue?vue&type=script&setup=true&lang=js"

import "./ZdravetoView.vue?vue&type=style&index=0&id=712f59c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712f59c6"]])

export default __exports__